<template>
  <div class="wrap-banner hidden-sm-and-down">
    <v-layout row wrap align-center justify-center>
      <vue-particles
          color="#0d1627"
          linesColor="#0d1627"
          :clickEffect="false"
          :particlesNumber="150"
        ></vue-particles>
       <v-flex lg12 sm12 xs12>
        <div style="height:15px"></div>
      </v-flex>
      <v-flex xl1 lg1 sm1 xs1 style="background: transparent" >
        <v-img :src="require('@/assets/rpa.png')" width="90"></v-img>
      </v-flex>
      <v-flex xl7 lg7 sm7 xs7 class="text-xs-center">
        <div class="display-1 font-weight-black">{{titulo}}</div>
      </v-flex>
       <v-flex xl1 lg1 sm1 xs1 style="background: transparent" >
        <v-img :src="require('@/assets/logo_oficial_ministerio_justicia_1024.png')" width="110"></v-img>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titulo: "Registro Público de la Abogacía"
    };
  }
};
</script>
<style>
.asd {
  background: transparent;
}
#logo {
  width: 220px;
  height: 120px;
  background: transparent url("../assets/logoMin.png") no-repeat;
  background-size: 90%;
  background-position: 50%;
  margin: 0 auto;
  background-color: hsla(0, 0%, 96%, 0.3);
}
.particles-js-canvas-el {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.wrap-banner {
  position: relative;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-flex;
  display: flex;
  height: 200;
  justify-content: center;
}
</style>




// WEBPACK FOOTER //
// src/components/Head.vue